import jschardet from 'jschardet';
import iconv from 'iconv-lite';

const readFileAsArrayBuffer = (file) => {
  if (typeof file.arrayBuffer === 'function') {
    return file.arrayBuffer();
  }
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsArrayBuffer(file);
  });
};

const uint8ArrayToBinaryString = (bytes) => {
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return binary;
};

const normalizeEncoding = (encoding) => {
  const map = {
    ascii: 'utf-8',
    utf8: 'utf-8',
    'utf-16le': 'utf16-le',
    'windows-1252': 'win1252',
    'iso-8859-1': 'latin1'
  };
  return map[encoding] || encoding;
};

export const convertFileToUtf8 = async (file) => {
  const arrayBuffer = await readFileAsArrayBuffer(file);
  const buffer = new Uint8Array(arrayBuffer);

  // Detect encoding using jschardet (expects a binary string)
  const detection = jschardet.detect(uint8ArrayToBinaryString(buffer));
  let encoding = detection?.encoding?.toLowerCase() || 'utf-8';
  const confidence = detection?.confidence || 0;

  // Fall back to utf-8 when confidence is too low
  if (confidence < 0.7) {
    encoding = 'utf-8';
  }

  let bytes = buffer;

  // Strip UTF-8 BOM
  if (
    bytes.length >= 3 &&
    bytes[0] === 0xef &&
    bytes[1] === 0xbb &&
    bytes[2] === 0xbf
  ) {
    bytes = bytes.slice(3);
    encoding = 'utf-8';
  }
  // Strip UTF-16 LE BOM
  else if (bytes.length >= 2 && bytes[0] === 0xff && bytes[1] === 0xfe) {
    bytes = bytes.slice(2);
    encoding = 'utf-16le';
  }
  // Strip UTF-16 BE BOM
  else if (bytes.length >= 2 && bytes[0] === 0xfe && bytes[1] === 0xff) {
    bytes = bytes.slice(2);
    encoding = 'utf-16be';
  }

  encoding = normalizeEncoding(encoding);

  if (!iconv.encodingExists(encoding)) {
    throw new Error(
      `Unsupported file encoding (${encoding}). Please save the file as UTF-8 and try again.`
    );
  }

  const text = iconv.decode(bytes, encoding);
  const utf8Bytes = iconv.encode(text, 'utf-8');

  return new File([utf8Bytes], file.name, {
    type: file.type || 'text/csv'
  });
};
